export default __webpack_public_path__ + "static/media/IndigenousPeoples_en.da5e0e09.svg";